import { isApiName } from 'self-service-api/core/type-guards/apiName';
import { useGetAddOnsQuery } from '../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc.hooks';
import { useAppSelector } from '../reducers';
import { isUngatedForBreezeIntelligenceSelector, isUngatedForHubSpotCreditsSelector } from '../selectors/GatingSelectors';
import { getAddOnsFromApiNamesWithTranslations } from '../utils/addOnsUtils';
import { useGlobalLoading } from './loadingHooks';
import { useEligibleBreezeProducts } from './useEligibleBreezeProducts';
export const useAllEligibleAddOnsWithTranslations = ({
  searchTerm = ''
} = {}) => {
  const isAppReady = useGlobalLoading();
  const isUngatedForBreezeIntelligence = useAppSelector(isUngatedForBreezeIntelligenceSelector);
  const {
    data: addOnsData,
    loading: addOnsLoading
  } = useGetAddOnsQuery();
  const isUngatedForHubSpotCredits = useAppSelector(isUngatedForHubSpotCreditsSelector);
  /**
   * @temporary TODO: This should be removed once hubspot credits is live
   * @expiration 2025-06-09
   * @deprecated
   */
  const {
    eligibleBreezeApiNames,
    loading: getEligibleBreezeSkusLoading
  } = useEligibleBreezeProducts({
    skip: isUngatedForHubSpotCredits
  });
  const eligibleAddOnApiNames = addOnsData === null || addOnsData === void 0 ? void 0 : addOnsData.eligibleAddOns.filter(isApiName);
  const combinedList = [...(eligibleBreezeApiNames || []), ...(eligibleAddOnApiNames || [])];
  const {
    filteredAddOns,
    totalAddOns
  } = useAppSelector(state => {
    if (!isAppReady) {
      return {
        filteredAddOns: [],
        totalAddOns: 0
      };
    }
    return getAddOnsFromApiNamesWithTranslations(state, combinedList, searchTerm);
  });
  return {
    addOns: filteredAddOns,
    totalAddOns,
    loading: !isAppReady || addOnsLoading || isUngatedForBreezeIntelligence && getEligibleBreezeSkusLoading,
    loaded: isAppReady && !addOnsLoading && !getEligibleBreezeSkusLoading
  };
};